export default {
  labels: {
    custom: 'Personalizado - disponible bajo solicitud',
    was: 'Era {{amount}} – descuento anual aplicado',
  },
  tags: {
    preferred: 'Especialmente popular',
    net_one_time: 'neto único pago',
    annual_discount: '-{{percentage}}% anual',
  },
  buttons: {
    select_plan: 'Elegir este plan',
  },
};
